import type { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@akina/infra";
import { LoadingOverlay } from "@akina/presentation";
import { AppRoutes } from ".";

const GuestRoute: FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <LoadingOverlay />;
  if (isAuthenticated) return <Navigate to={AppRoutes.Dashboard} replace />;
  return <Outlet />;
};

export default GuestRoute;
